import React from 'react';
import S from './style';

function AddCard(properties) {
  return (
    <S.Card {...properties}>
      <S.AddIcon />
      <S.Link>New retrospective</S.Link>
    </S.Card>
  );
}

export default AddCard;
